<div class="container">
  <h1>Status</h1>

  <h3>Logged:</h3>
  <pre>{{logged}}</pre>

  <h3>Cookies:</h3>
  <pre>{{cookies}}</pre>
  <button (click)="resetCookies()">Reset cookies</button>

  <h3>LocalStorage:</h3>
  <pre>{{localstorage}}</pre>
  <button (click)="resetLocalStorage()">Reset localStorage</button>
</div>
